import {Handle, Position} from '@xyflow/react';
import type {CSSProperties} from 'react';


const LOGICAL_HANDLE_STYLE: CSSProperties = {
    opacity: 0,
    pointerEvents: 'none',
};


// 依赖 xyflow 的手柄连接点
export function InternalHandle({side}: {
    side: 'left' | 'right';
}) {
    return (
        <Handle
            id={side === 'left' ? 'canvas-target-logical' : 'canvas-source-logical'}
            type={side === 'left' ? 'target' : 'source'}
            position={side === 'left' ? Position.Left : Position.Right}
            className="canvas-logical-handle !h-px !w-px !min-h-0 !min-w-0 !border-0 !bg-transparent"
            style={LOGICAL_HANDLE_STYLE}
        />
    );
}
